import { Injectable } from '@angular/core';
import {Http, Response, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../../environments/environment';

@Injectable()
export class ComprarService {

  private token:string;
  constructor(private http:Http) {

    this.token=null;

  }

    getDias(): Promise<String[]>   {

    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url=environment.serviceUrl+'dia';
    return this.http.get(url,{headers: headers}).toPromise()
      .then(response => {
        return response.json() as String[];
      }).catch(this.handleError)

    }

     addCompra(compra:string): Promise<String>   {

        let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
        let url=environment.serviceUrl+'compra';
        return this.http.post(url,compra,{headers: headers}).toPromise()
          .then(response => {
            return response.json() as String;
          }).catch(this.handleError)

    }

    apiParques(compra: string): Promise<String> {
      let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
      let url=environment.apiUpgrade+'/api/parques';
      return this.http.post(url,compra,{headers: headers}).toPromise()
        .then(response => {
          return response.json() as String;
        }).catch(this.handleError)
    }

    orderPaypal(usd:number, refventa): Promise<String>   {
      let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
      let url=environment.apipaypal+'order';
      return this.http.post(url,{usd, refventa},{headers: headers}).toPromise()
        .then(response => {
          return response.json() as String;
        }).catch(this.handleError)

    }


    login(): Promise<any> {

      let headers = new Headers({
                                'Content-Type': 'application/json; charset=utf-8',
                                'Access-Control-Allow-Origin':'*'
                                 });
      let url=environment.lealCoinUrl+'login_cajero';
      var user:{
            usuario:"segurosmedicosi",
            contrasena:"123"
      }

    return this.http.post(url, user,{headers: headers}).toPromise()
      .then(response => {
          var data=response.json() as any;
          this.token=data.token;
          debugger;
      }).catch(this.handleError)
  }
  consultarUID(id:string): Promise<any>   {

    if(!this.token) this.login();

    let headers = new Headers({
                                'Content-Type': 'application/json; charset=utf-8',
                                'Access-Control-Allow-Origin':'*',
                                'Authorization': 'bearer '+ this.token
                              });

    let url=environment.lealCoinUrl+'consultar_uid/'+id+'/'+environment.lealCoinId;

    return this.http.get(url,{headers: headers}).toPromise()
      .then(response => {
        return response.json() as any;
      }).catch(this.handleError)
}


    /**
    * Handles error thrown during HTTP call
    * @param error:any
    * @returns {Promise<never>}
    */
    private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); //
    return Promise.reject(error.message || error);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/general/comprar.service.ts